module.exports = __webpack_public_path__ + "static/beach-36e1e3f9259c4b1a17fd76ea1ae6c141.png";